<template>
  <spr-dialog name="contacts" :show="show" :title="title" @confirm="handleConfirm" @open="handleOpen" @update:show="(flag) => this.$emit('update:show', flag)">
    <el-form :model="Form" ref="form" label-suffix="：" label-width="110px" :rules="ContactRules">
      <el-form-item label="联系人名称" prop="Name">
        <el-input style="width: 100%;" v-model="Form.Name"></el-input>
      </el-form-item>
      <el-form-item label="性别" prop="Gender">
        <el-radio class="radio" v-model="Form.Gender" label="male">男</el-radio>
        <el-radio class="radio" v-model="Form.Gender" label="female">女</el-radio>
      </el-form-item>
      <el-form-item label="生日">
        <el-date-picker type="date" v-model="Form.Birthdate" :editable="false"></el-date-picker>
      </el-form-item>
      <el-form-item label="手机号" prop="Mobile">
        <el-input style="width: 100%;" v-model="Form.Mobile"></el-input>
      </el-form-item>
      <el-form-item label="QQ">
        <el-input style="width: 100%;" v-model="Form.QQ"></el-input>
      </el-form-item>
      <el-form-item label="微信">
        <el-input style="width: 100%;" v-model="Form.Weixin"></el-input>
      </el-form-item>
      <el-form-item label="职位" prop="JobTitle">
        <el-input style="width: 100%;" v-model="Form.JobTitle"></el-input>
      </el-form-item>
      <el-form-item label="办事处" prop="Street">
        <spr-address class="work-place"
          :province-id.sync="Form.ProvinceId"
          :city-id.sync="Form.CityId"
          :county-id.sync="Form.CountyId"
          :address.sync="Form.Street"
          width="400px"
        ></spr-address>
      </el-form-item>
    </el-form>
  </spr-dialog>
</template>

<script>
import SprDialog from './Dialog'
import SprAddress from '@/components/common/Address'
import _ from 'lodash'

export default {
  data() {
    return {
      Form: {},
      ContactRules: {
        Name: [{required: true, message: '该字段必填', trigger: 'blur'}],
        Gender: [{required: true, message: '该字段必填', trigger: 'blur'}],
        Mobile: [{required: true, message: '该字段必填', trigger: 'blur'}],
        JobTitle: [{required: true, message: '该字段必填', trigger: 'blur'}],
        Street: [{required: true, message: '该字段必填', trigger: 'blur'}],
      },
    }
  },
  props: {
    form: null,
    show: Boolean,
    title: String,
  },
  methods: {
    handleConfirm() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          this.$emit('confirm', this.Form)
        }
      })
    },
    handleOpen() {
      const form = this.form.Id ? _.pick(this.form, [
        'Id',
        'Name',
        'Gender',
        'Birthdate',
        'Mobile',
        'QQ',
        'Weixin',
        'JobTitle',
        'ProvinceId',
        'CityId',
        'CountyId',
        'Street',
      ]) : {
        Name: null,
        Gender: null,
        Birthdate: null,
        Mobile: null,
        QQ: null,
        Weixin: null,
        JobTitle: null,
        ProvinceId: null,
        CityId: null,
        CountyId: null,
        Street: null,
      }
      this.$set(this, 'Form', form)
    },
  },
  components: {
    SprDialog,
    SprAddress,
  },
}
</script>

<style lang="less">
.work-place.address-box {
  display: block;
  width: auto !important;
  .el-col {
    width: auto;
    margin-right: 6px;
    &:nth-child(3), &:nth-child(4) {
      margin-right: 0;
    }
  }
  .province, .city, .county {
    width: 126px;
  }
  .address {
    width: 390px;
    margin-top: 6px;
  }
}
.inner-form {
  // margin-left: 67px;
  .el-form-item {
    margin: 0;
    .el-form-item__content {
      min-width: 100px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// ContactsDialog.vue?9a49fbfc